
import config from '../config';
import './OurServices.css'; 

const Services = () => {
  const servicesData = [
    {
      id: 1,
      icon: `${config.paths.testimonials}cfo-icon-website1.jpg.webp`,
      title: "Virtual CFO Services",
      description: "Performing full-service accounting and finance functions based on pre-agreed deliverables with 100% accountability.",
      link: "https://cfobridge.com/service/virtual-cfo-services"
    },
    {
      id: 2,
      icon: `${config.paths.testimonials}asset-256-28.png.webp`,
      title: "Interim CFO Services",
      description: "Helping you navigate your business through transition periods with experienced CFOs.",
      link: "https://cfobridge.com/service/interim-cfo-services"
    },
    {
      id: 3,
      icon: `${config.paths.testimonials}asset-246-281.png.webp`,
      title: "Financial Planning & Analysis",
      description: "Navigate your business' financial future with confidence with comprehensive planning & analysis services from CFO Bridge",
      link: "https://cfobridge.com/service/financial-planning-analysis"
    },
    {
      id: 4,
      icon: `${config.paths.testimonials}asset-232-28.png.webp`,
      title: "Working Capital Management",
      description: "Unlock the trapped cash in your business with working capital management",
      link: "https://cfobridge.com/service/working-capital-management"
    },
    {
      id: 5,
      icon: `${config.paths.testimonials}asset-237-281.png.webp`,
      title: "M&A and Fundraising",
      description: "Let us help you achieve business goals like raising capital, M&A, global expansion, and succession planning with a multi-faceted approach that generates long-term value.",
      link: "https://cfobridge.com/service/ma-and-fundraising"
    },
    {
      id: 6,
      icon: `${config.paths.testimonials}asset-235-281.png.webp`,
      title: "Taxation",
      description: "Optimize taxes, minimize litigations and surprises and stay compliant with our comprehensive taxation accounting support.",
      link: "https://cfobridge.com/service/taxation"
    },
    {
      id: 7,
      icon: `${config.paths.testimonials}asset-244-281_png.webp`,
      title: "SME IPO",
      description: "Taking your company public is more than just raising funds it's about scaling impact, enhancing valuation, and institutionalizing your business. At CFO Bridge, we specialize in guiding small and medium enterprises (SMEs) through their IPO journey with a strategic, compliance-first approach that ensures long-term sustainability and leadership.",
      link: "https://cfobridge.com/service/sme-ipo"
    },
    {
      id: 8,
      icon: `${config.paths.testimonials}asset-253-28_png1.webp`,
      title: "ERP Implementation & Transformation",
      description: "From system selection to post-go-live optimisation, we guide you through every step, so your ERP investment truly delivers business value. Request your complimentary ERP Health Check today and take the first step toward digital transformation.",
      link: "https://cfobridge.com/service/erp-implementation-transformation"
    },
    {
      id: 9,
      icon: `${config.paths.testimonials}asset-318-281_png.webp`,
      title: "Technical Consultation & Advisory",
      description: "Whether you're navigating a new GAAP or preparing for your next audit, CFO Bridge ensures you're always a step ahead. Book a free discovery call with our team.",
      link: "https://cfobridge.com/service/technical-consultation-advisory"
    }
  ];

  return (
    <section className="py-16 bg-gray-50">

      <div className="max-w-7xl mx-auto px-4" id="services">
        <div className="container">
          <div className="text-center mb-16">
            <h2 className="section-title" style={{ marginBottom: "25px" }}>
              CFO Services that Makes Us Unique
            </h2>
            <p style={{ marginBottom: "60px" }}>CFO Bridge USA offers tailored financial leadership through our expert Virtual CFO and Fractional CFO services, giving businesses the flexibility to access top-tier financial expertise without the cost of a full-time CFO. Whether you need an experienced partner for strategic direction, short-term support with an Interim CFO, or ongoing efficiency through an Outsourced CFO solution, our dedicated CFO consultants provide the insights and strategies to drive profitability, scalability, and sustainable growth.</p>
          </div>

          <div className="space-y-0">
            {servicesData.map((service, index) => (
              <a
                key={service.id}
                href={service.link}
                className={`service-card ${index % 2 !== 0 ? 'reverse' : ''}`}
              >
                <div className="left-part">
                  <div className="icon-container">
                    <img
                      src={service.icon}
                      alt={`${service.title} icon`}
                      onError={(e) => {
                        // Fallback icon if image fails to load
                        e.target.style.display = 'none';
                        e.target.parentNode.innerHTML = `
                        <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="#014293" strokeWidth="1.5">
                          <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                          <line x1="8" y1="21" x2="16" y2="21"/>
                          <line x1="12" y1="17" x2="12" y2="21"/>
                        </svg>
                      `;
                      }}
                    />
                  </div>
                  <h3 className="service-title">
                    {service.title}
                  </h3>
                </div>
                <div className="right-part">
                  <p className="service-description">
                    {service.description}
                  </p>
                  <span className="learn-more-btn">
                    <span>Learn More</span>
                    <svg
                      className="arrow-icon"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;